import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UrlService } from '../../commons/calendar/prevUrl.service';
import { TimestampFormatPipe } from '../../commons/timestampFormatPipe';
import { CollaboratoreService } from '../../services/domain/collaboratore.service';
import { NavigatorService } from '../../services/navigator.service';
import { SondaggioService } from '../../services/sondaggio/sondaggio.service';
import { CollaboratoreDTO } from '../../shared/dto/domain/collaboratore';
import { ResponseQueryByCriteria } from '../../shared/dto/responseQueryByCriteria';
import { SondaggioDTO, SondaggioOptionDTO } from '../../shared/dto/sondaggi/sondaggio';
import { GenericDetailComponent } from '../../shared/GenericDetailComponent';

@Component({
  selector: 'creazione-sondaggi-detail',
  templateUrl: './creazione-sondaggi-detail.component.html',
  styleUrls: ['./creazione-sondaggi-detail.component.scss']
})

export class CreazioneSondaggiDetailComponent extends GenericDetailComponent implements OnInit {

  collaboratori: CollaboratoreDTO[];
  previousUrlService: Observable<string> = this.urlService.previousUrl$;
  previousUrl: string;
  sondaggioId: number;
  dataMin: Date;
  bloccaModifica: boolean;
  sondaggio: SondaggioDTO;
  newOption: FormControl;
  isMultiple: boolean = false;
  currentOptions: SondaggioOptionDTO[] = [];
  currentOptionModificate: boolean;

  constructor(
    private urlService: UrlService,
    private collaboratoreService: CollaboratoreService,
    activeRoute: ActivatedRoute,
    snackBar: MatSnackBar,
    navigatorService: NavigatorService,
    dialog: MatDialog,
    router: Router,
    timestampFormatPipe: TimestampFormatPipe,
    private sondaggioService: SondaggioService,
    dateAdapter: DateAdapter<Date>
  ) {
    super(
      navigatorService,
      dialog,
      router,
      dateAdapter,
      activeRoute,
      snackBar,
      timestampFormatPipe
    );
    this.form = new FormGroup({
      id: new FormControl(''),
      dataScadenza: new FormControl('', Validators.required),
      titolo: new FormControl('', Validators.required),
      creatore: new FormControl('', Validators.required),
      descrizione: new FormControl(''),
      numMaxRisposte: new FormControl(''),
      insertDate: new FormControl({ value: '', disabled: true }),
      insertUser: new FormControl({ value: '', disabled: true }),
      updateDate: new FormControl({ value: '', disabled: true }),
      updateUser: new FormControl({ value: '', disabled: true }),
      newOption: new FormControl(''),
      isMultiple: new FormControl(''),
    });
  }

  ngOnInit() {
    this.sondaggioId = Number(this.activeRoute.snapshot.paramMap.get("id"));
    if (this.sondaggioId != 0 && this.sondaggioId != null) {
      this.read();
    } else {
      this.sondaggio = new SondaggioDTO();
    }
    this.navigatorService.collaboratore.subscribe(
      (res: CollaboratoreDTO) => {
        this.form.get("creatore").setValue(res);
      }
    );
    this.collaboratoreService.collaboratoreList(
      0,
      9999,
      'ASC',
      'nome',
      '').subscribe(
        (res: ResponseQueryByCriteria<CollaboratoreDTO>) => {
          console.log("response : " + res);
          this.collaboratori = res.content;
        }
      );
    this.urlService.previousUrl$.subscribe((previousUrl: string) => {
      this.previousUrl = previousUrl;
    });
    this.dataMin = new Date();
  }

  save() {
    if(this.sondaggio.id != null) {
      if(this.sondaggio.risposte.length != 0 && this.currentOptionModificate) {
        this.confirm("Esistono delle risposte a questo sondaggio, se procedi tutte le risposte verranno invalidate. Vuoi salvare le modifiche?").subscribe(result => {
          if (result) {
            this.update();
          }  
        });
      } 
      else {
        this.update();
      }
    } else {
      this.create();
    }
  }

  isFormValid(): boolean {
    let numMaxRisp = this.form.get("numMaxRisposte")?.value;
    return this.form.valid
    && this.currentOptions?.length > 1 
    && (numMaxRisp == null || this.currentOptions?.length >= numMaxRisp);
  }

  create() {
    if (this.isFormValid()) {
      this.formToDto();
      console.log("sondaggio : " + this.sondaggio);
      this.sondaggioService.create(this.sondaggio).subscribe(
        (res: SondaggioDTO) => {
          console.log("response : " + res);
          this.snackBar.open("Sondaggio creato con successo!", null, { duration: 3000 });
          this.sondaggio = res;
          this.sondaggioId = this.sondaggio.id;
          this.dtoToForm();
        },
      );
    }
  }

  read() {
    this.sondaggioService.read(this.sondaggioId).subscribe(
      (res: SondaggioDTO) => {
        console.log("response : " + res);
        this.sondaggio = res;
        this.sondaggioId = res.id;
        this.dtoToForm();
      }
    );
  }

  update() {
    if (this.isFormValid() && this.form.dirty) {
      if(this.isJappTenantAdmin()){ 
        this.salvataggio();
      }else{
        this.navigatorService.collaboratore.subscribe((currentUser: CollaboratoreDTO) => {
          if (this.sondaggio.creatore && this.sondaggio.creatore.id === currentUser.id) {
            this.salvataggio();
          } else {
            this.snackBar.open("Non hai i permessi per modificare questo sondaggio.", null, { duration: 3000 });
          }
        });
      }
    }
  }

  delete() {
    if(this.isJappTenantAdmin()){ 
      this.cancellazione();
    }else{
      this.navigatorService.collaboratore.subscribe((currentUser: CollaboratoreDTO) => {
        if (this.sondaggio.creatore && this.sondaggio.creatore.id === currentUser.id) {
          this.cancellazione();
        } else {
          this.snackBar.open("Non hai i permessi per eliminare questo sondaggio.", null, { duration: 3000 });
        }
      });
    }
  }

  isNewOptionValid(): boolean {
    const val = this.form.get("newOption").value;
    return val != null && val != '';
  }

  addOption() {
    if (this.isNewOptionValid()) {
      if(this.currentOptions == null) {
        this.currentOptions = [];
      }

      let newOption = new SondaggioOptionDTO();
      newOption.name = this.form.get("newOption").value;
      this.currentOptions.push(newOption);
      this.currentOptionModificate = true;

      this.form.get("newOption").setValue('');
    }
  }

  removeOption(option: SondaggioOptionDTO) {
    const index = this.currentOptions?.indexOf(option);
    if (index != null && index >= 0) {
      this.currentOptions.splice(index, 1);
      this.currentOptionModificate = true;
      this.form.markAsDirty();
    }
  }

  isMultipleAnswer() {
    this.isMultiple = !this.isMultiple;
    if(!this.isMultiple) {
      this.form.get("numMaxRisposte").setValue('');
    }
  }

  getNumOptions(): number {
    return (this.currentOptions == null) ? 0 : this.currentOptions.length;
  }

  private salvataggio() {
    this.confirm("Sei sicuro di voler sovrascrivere il sondaggio?").subscribe(result => {
      if (result) {
        this.formToDto();
        this.sondaggioService.update(this.sondaggio).subscribe(
          (res) => {
            this.snackBar.open("Salvataggio avvenuto con successo!", null, { duration: 3000 });
            this.read();
          }
        );
      }
    });
  }

  private cancellazione() {
    this.confirm("Sei sicuro di voler cancellare il sondaggio?").subscribe(result => {
      if (result) {
        this.sondaggioService.delete(this.sondaggio.id).subscribe(
          (res) => {
            console.log("response : " + res);
            this.snackBar.open("Cancellazione avvenuta con successo!", null, { duration: 3000 });
            this.router.navigate(["/creazione-sondaggi"]);
          }
        );
      }
    });
  }

  private formToDto(): void {
    let numMaxRisposte = this.form.get("numMaxRisposte").value

    this.sondaggio.dataScadenza = this.form.get("dataScadenza").value;
    this.sondaggio.titolo = this.form.get("titolo").value;
    this.sondaggio.creatore = this.form.get("creatore").value;
    this.sondaggio.descrizione = this.form.get("descrizione").value;
    this.sondaggio.options = this.currentOptions;
    this.sondaggio.numMaxRisposte = (numMaxRisposte != null && numMaxRisposte > 1) ? numMaxRisposte : 1;
  }

  private dtoToForm(): void {
    this.form.get("id").setValue(this.sondaggio.id);
    this.form.get("dataScadenza").setValue(this.sondaggio.dataScadenza);
    this.form.get("titolo").setValue(this.sondaggio.titolo);
    this.form.get("creatore").setValue(this.sondaggio.creatore);
    this.form.get("descrizione").setValue(this.sondaggio.descrizione);
    this.currentOptions = this.sondaggio.options;
    this.currentOptionModificate = false;
    this.form.get("numMaxRisposte").setValue(this.sondaggio.numMaxRisposte);
    this.isMultiple = this.sondaggio.numMaxRisposte != null && this.sondaggio.numMaxRisposte > 1;
    this.form.get("insertDate").setValue(this.timestampFormatPipe.transform(this.sondaggio.insertDate));
    this.form.get("insertUser").setValue(this.sondaggio.insertUser);
    this.form.get("updateDate").setValue(this.timestampFormatPipe.transform(this.sondaggio.updateDate));
    this.form.get("updateUser").setValue(this.sondaggio.updateUser);
    this.form.markAsPristine();
  }
}